import React from "react";
import { Field, ErrorMessage } from "formik";

/**
 * Formik-compatible common form edit fields.
 */

export const FormField = (props) => {
    return <div className="form-group row">
               <label className="col-form-label col-sm-3">{props.label}</label>
               <div className="col">
                   <Field type="text" name={props.name} className="form-control"/>
                   <ErrorMessage name={props.name} component="div"/>
                   {props.description && <div>{props.description}</div>}
               </div>
           </div>;
};

export const NumberField = (props) => {
    return <div className="form-group row">
               <label className="col-form-label col-sm-3">{props.label}</label>
               <div className="col-sm-6">
                   <Field type="number" name={props.name} className="form-control"/>
                   <ErrorMessage name={props.name} component="div"/>
               </div>
           </div>;
};

export const SelectOption = props => (<option value={props.value}>{props.label}</option>);

export const SelectField = props => {
    return <div className="form-group row">
               <label className="col-form-label col-sm-3">{props.label}</label>
               <div className="col-sm-6">
                   <Field component="select" className="form-control" name={props.name}>
                       {props.values.map(v => (<SelectOption key={v.value} {...v}/>))}
                   </Field>
               </div>
           </div>;
};

// TODO poista checked, kun tämä korjattu: https://github.com/jaredpalmer/formik/issues/1050
export const CheckboxField = (props) => {

    return <div className="form-group row">
               <div className="form-check" style={{ paddingLeft: "2.25rem" }}>
                   <Field type="checkbox" className="form-check-input" name={props.name} checked={props.value} id={
props.name}/>
                   <label className="form-check-label" htmlFor={props.name}>{props.label}</label>
                   {props.description && <div>{props.description}</div>}
               </div>
           </div>;
};